import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        user: '='
    },
    template: `
        <div class="modal-header">
            <h2>{{ 'userNps.Feedback' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div ng-if="vm.showError" class="alert alert-danger">{{ 'userNps.Please answer all mandatory questions' | translate }}</div>
            <div class="question clear">
                <h3>{{ vm.NPS_QUESTION_TYPE_ENUM.LABELS.RECOMMEND_COURSY_2021_MAY }}<span class="red">*</span></h3>
                <div class="checkboxes06">
                    <ul>
                        <li class="size-wide">
                            <input type="radio" ng-model="vm.form.model.rating" ng-value="0" name="r01">
                            <label>0<br>{{ 'userNps.Extremely unlikely' | translate }}</label>
                        </li>
                        <li><input type="radio" ng-model="vm.form.model.rating" ng-value="1" name="r01"><label>1</label></li>
                        <li><input type="radio" ng-model="vm.form.model.rating" ng-value="2" name="r01"><label>2</label></li>
                        <li><input type="radio" ng-model="vm.form.model.rating" ng-value="3" name="r01"><label>3</label></li>
                        <li><input type="radio" ng-model="vm.form.model.rating" ng-value="4" name="r01"><label>4</label></li>
                        <li><input type="radio" ng-model="vm.form.model.rating" ng-value="5" name="r01"><label>5</label></li>
                        <li><input type="radio" ng-model="vm.form.model.rating" ng-value="6" name="r01"><label>6</label></li>
                        <li><input type="radio" ng-model="vm.form.model.rating" ng-value="7" name="r01"><label>7</label></li>
                        <li><input type="radio" ng-model="vm.form.model.rating" ng-value="8" name="r01"><label>8</label></li>
                        <li><input type="radio" ng-model="vm.form.model.rating" ng-value="9" name="r01"><label>9</label></li>
                        <li class="size-wide">
                            <input type="radio" ng-model="vm.form.model.rating" ng-value="10" name="r10">
                            <label>10<br>{{ 'userNps.Extremely likely' | translate }}</label>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="question clear">
                <h3>{{ 'userNps.Please comment on your opinion' | translate }}</h3>
                <textarea ng-model="vm.form.model.comment" class="form-control w100p"></textarea>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'userNps.Submit answer' | translate }}</button></li>
                <li><button class="btn discrete" type="button" ng-click="vm.postpone()">{{ 'userNps.I do not wish to answer at the moment' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor (toastr, $translate, FormFactory, UserNpsResource, NPS_ORIGIN_TYPE_ENUM, NPS_QUESTION_TYPE_ENUM) {
        this.toastr = toastr;
        this.$translate = $translate;
        this.FormFactory = FormFactory;
        this.UserNpsResource = UserNpsResource;
        this.NPS_ORIGIN_TYPE_ENUM = NPS_ORIGIN_TYPE_ENUM;
        this.NPS_QUESTION_TYPE_ENUM = NPS_QUESTION_TYPE_ENUM;
    }

    $onInit () {
        this.showError = false;
        this.form = this.FormFactory.createFromResource(
            new this.UserNpsResource({
                userId: this.user.id
            })
        );

        this.form.model.questionType = this.NPS_QUESTION_TYPE_ENUM.KEYS.RECOMMEND_COURSY_2021_MAY;
        this.form.model.originType = this.NPS_ORIGIN_TYPE_ENUM.KEYS.ADMIN;
    }

    save () {
        this.form.model.postpone = false;
        this.form.save()
            .then(() => {
                this.toastr.success(this.$translate.instant('userNps.Thank you! We appreciate your feedback!'));
                this.uibModalInstance.close();
            })
            .catch(() => {
                this.showError = true;
            })
        ;
    }

    postpone () {
        this.form.model.postpone = true;
        this.form.save().then(() => this.uibModalInstance.close());
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/nps/index.js